export default "__VITE_ASSET__8c600c61__"